export const heroTransition = {
  delay: 0,
  ease: [0.45, 0, 0.55, 1],
  duration: 0.6,
};
